<template>
  <div>
    <nav class="navbar">
        <ul class="navbar-nav">
            <li class="logo">
                <router-link class="nav-link" :to="{ name: 'home' }">
                    <span class="link-text logo-text">КазМунайГаз</span>
                    <img class="" src="../assets/logo-picture.png" alt="">
                </router-link>
              </li>
            <!-- <div class="navbar-user">
                <img class="navbar-user-img" src="" alt="">
                <p class="navbar-user-info fullname">lidner</p>
                <address class="navbar-user-info"></address>
            </div> -->

            <li class="nav-item">

                <router-link class="side-nav-link" :to="{ name: 'home' }">
                    <i class="fas fa-home fa-menu"></i>
                    <span class="link-text">Главная</span>
                </router-link>

                <!-- <a href="" class="side-nav-link">
                    <i class="fas fa-home fa-menu"></i>
                    <span class="link-text">Главная</span>
                </a> -->
            </li>

          <li class="nav-item">
            <router-link class="side-nav-link" :to="{name: 'activate-profile'}" v-if="!this.$store.getters.isActiveAccount">
              <i class="far fa-bell fa-menu"></i>
              <span class="link-text">Активация учетки</span>
            </router-link>
          </li>

            <!-- <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'metals' }">
                    <i class="fas fa-list-alt fa-menu"></i>
                    <span class="link-text">База металлов</span>
                </router-link>
            </li> -->

            <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'create-report' }" v-if="this.$store.getters.isActiveAccount && accessLevel(USER.ouser.role, 1)">
                    <i class="fas fa-folder-plus fa-menu"></i>
                    <span class="link-text">Формирование отчета</span>
                </router-link>
            </li>

            <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'report-statuses' }" v-if="this.$store.getters.isActiveAccount && accessLevel(USER.ouser.role, 3)">
                    <i class="far fa-file fa-menu"></i>
                    <span class="link-text">Статусы отчетов</span>
                </router-link>
            </li>


            <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'my-reports' }" v-if="this.$store.getters.isActiveAccount">
                    <!-- <i class="fas fa-folder-plus fa-menu"></i> -->
                    <i class="far fa-file fa-menu"></i>
                    <span class="link-text">Мои отчеты</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'reports' }" v-if="this.$store.getters.isActiveAccount">
                    <i class="fas fa-file fa-menu"></i>
                    <span class="link-text">Другие отчеты</span>
                </router-link>
            </li>


         <li class="nav-item">
              <router-link class="side-nav-link" :to="{ name: 'check-tmz-step' }" v-if="this.$store.getters.isActiveAccount  && accessLevel(USER.ouser.role, 1)">
                <i class="fas fa-chart-pie fa-menu"></i>
                <span class="link-text">Формирования ТМЗ Отчета</span>
              </router-link>
            </li>


          <li class="nav-item">
            <router-link class="side-nav-link" :to="{ name: 'tmz-my-report' }" v-if="this.$store.getters.isActiveAccount">
              <i class="fas fa-rss fa-menu"></i>
              <span class="link-text">Мои Отчеты ТМЗ</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link class="side-nav-link" :to="{ name: 'tmz-not-report' }" v-if="this.$store.getters.isActiveAccount">
              <i class="fas fa-book-open fa-menu"></i>
              <span class="link-text">Отчеты ТМЗ</span>
            </router-link>
          </li>
            <!-- <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'analytics' }" v-if="this.$store.getters.isActiveAccount">
                    <i class="fas fa-chart-pie fa-menu"></i>
                    <span class="link-text">Аналитика</span>
                </router-link>
            </li>
             <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'news' }" v-if="this.$store.getters.isActiveAccount">
                    <i class="fas fa-rss fa-menu"></i>
                    <span class="link-text">Новости</span>
                </router-link>
            </li>
             <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'handbook' }" v-if="this.$store.getters.isActiveAccount">
                    <i class="fas fa-book-open fa-menu"></i>
                    <span class="link-text">Справочники</span>
                </router-link>
            </li> -->
            <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'learning' }" v-if="this.$store.getters.isActiveAccount">
                    <i class="fas fa-chalkboard-teacher fa-menu"></i>
                    <span class="link-text">Обучение</span>
                </router-link>
            </li>
             <!-- <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'help' }" v-if="this.$store.getters.isActiveAccount">
                    <i class="fas fa-question fa-menu"></i>
                    <span class="link-text">Помощь</span>
                </router-link>
            </li>

            <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'finished' }">
                    <i class="fas fa-file-contract fa-menu"></i>
                    <span class="link-text">Готовые отчеты</span>
                </router-link>
            </li> -->
            <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'messenger' }">
                    <i class="fas fa-comments fa-menu"></i>
                    <span class="link-text">Чат</span>
                </router-link>
            </li>

            <li class="nav-item">
                <router-link class="side-nav-link" :to="{ name: 'logout' }">
                    <i class="fas fa-sign-out-alt fa-menu"></i>
                    <span class="link-text">Выйти</span>
                </router-link>
                <!-- <a href="" class="side-nav-link">
                    <i class="fas fa-sign-out-alt fa-menu"></i>
                    <span class="link-text">Выйти</span>
                </a> -->
            </li>

        </ul>
    </nav>
  </div>

</template>

<script>
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'isActiveAccount',
      'USER'
    ])
  },
  methods: {
    openModal() {
      let body = document.body;
      body.classList.add("show-auth-modal", "noscroll");
      this.showModal = !this.showModal;

      // Close modal if ESC key tapped
      body.addEventListener('keyup', (e) => {
        if (e.keyCode == 27) {
          this.closeModal()
        }
      });
    },
    accessLevel(roles, level) {
      if (roles) {
        let arr = Object.keys(JSON.parse(JSON.stringify(this.USER.ouser.role)));
        for (const role in arr) {
          if (roles[role].access_level === level) {
            return true;
          }
        }
        return false;
      }
      return false;
    },
    closeModal() {
      let body = document.body;
      body.classList.remove('show-auth-modal', 'noscroll');
    },
  },


}
</script>

<style>
/* Sidenav */
.navbar {
  display: block;
  width: 5rem;
  height: 100%;
  position: fixed;
  /* background-color: white; */
  background-color: #36429E;
  transition: width 500ms ease;
  overflow: auto;
  z-index: 100;
}

.navbar::-webkit-scrollbar {
  display: none;
}

.navbar-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.side-nav-link:focus {
  outline: none;
  border: none;
}

/* Active tab */

.navbar a.router-link-exact-active {
    background: white;
    color: #36429E;
}




.logo-nav {
  width: 60px;
  display: none;
  margin-left: 1rem;
  display: inline;
  position: absolute;
  left: -999px;
  transition: 500ms;
}


/* Navbar user */
.navbar-user {
  text-align: center;
}

.navbar-user-img {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  object-fit: cover;
}

.navbar-user-info {
  opacity: 1;
  /* text-align: center; */
}

.navbar-user-info.fullname {
  font-weight: bold;
}


.nav-item {
  width: 100%;
}

.nav-item:hover {
  background-color: #2A358A;
  cursor: pointer;
}

/* Set last link to bottom of sidenav */
.nav-item:last-child {
  margin-top: auto;
}

.side-nav-link {
  display: flex;
  align-items: center;
  height: 5rem;
  /* color: #575757; */
  color: white;
  text-decoration: none !important;
  /* filter: grayscale(100%) opacity(0.7); */
  filter: grayscale(0);
  transition: 600ms;
}

.side-nav-link.side-nav-link-logo {
  display: flex;
  align-items: center;
  height: 5rem;
  /* color: #fff; */
  text-decoration: none;
  filter: grayscale(0%) opacity(1);
  transition: 600ms;
}

.side-nav-link .badge {
  position: absolute;
  top: 10px;
  right: 15px;
  padding: 5px 10px;
  border-radius: 50%;
  color: #1bc47d;
}

.side-nav-link:hover {
  filter: grayscale(0%) opacity(1);
  /* background: #03E9F4; */
  /* color: #5769F8; */
}

.side-nav-link:hover .badge {
  /* color: #5769F8; */
}

.link-text {
  display: none;
  margin-left: 1rem;
  font-size: 1.2rem;
}

.side-nav-link svg {
  width: 2rem;
  min-width: 2rem;
  margin: 0 1.5rem;
}

.side-nav-link i::before {
  /* font-size: 2rem; */
  font-size: 25px;
  margin: 0 3.125rem;
}

.resized-i::before {
  font-size: 28px !important;
}

.side-nav-link span {
  margin-left: 3.5rem;
}

.fa-primary {
  color: #03E9F4;
}

.fa-secondary {
  color: #03E9F4;
}

.fas::before {
  width: 50px;
}

.fa-primary,
.fa-secondary {
  transition: 500ms;
}

.fa-menu {
  width: 50px;
}


.logo {
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 1rem;
  text-align: center;
  color: #fff;
  /* background: #34495e; */
  font-size: 1.5rem;
  letter-spacing: 0.3ch;
  width: 100%;
}

.logo img {
  transform: rotate(0deg);
  transition: 500ms;
  width: 90px;
  padding-top: 1rem;
}

.navbar:hover .logo img {
  transform: rotate(360deg);
}

.logo-text {
  display: inline;
  position: absolute;
  left: -999px;
  transition: 500ms;
  color: white;
  font-size: 24px;
  top: 2.5rem;
  letter-spacing: -2px;
}


/* Small screens */
@media only screen and (max-width: 600px) {
  .navbar {
    bottom: 0;
    width: 100vw;
    height: 5rem;
  }

  .logo {
    /* display: none; */
  }

  .navbar-nav {
    flex-direction: row;
  }

  .side-nav-link {
    justify-content: center;
  }

  main {
    margin: 0;
  }
}

/* Large screens */
@media only screen and (min-width: 600px) {
  .navbar {
    top: 0;
    width: 8rem;
    height: 100%;
  }

  .navbar:hover {
    width: 20rem;
  }

  .navbar:hover .link-text,
  .navbar:hover .logo-nav {
    display: inline;
  }

  .navbar:hover .navbar-user-info {
    opacity: 1;
  }

  /* .navbar:hover .logo svg {
      margin-left: 11rem;
  } */
  .navbar:hover .logo-nav {
    left: 0px;
  }

  .navbar:hover .link-text {
    display: inline;
  }

  .navbar:hover .logo img {
    margin-left: 11rem;
  }

  .navbar:hover .logo-text {
    left: 0px;
  }
}

/* auth Modal
-----------------------------------------*/
.auth-modal,
.auth-modal .overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000;
}

.auth-modal {
  overflow: hidden;
  position: fixed;
  opacity: 0.0;

  -webkit-transform: translate(500%, 0%);
  transform: translate(500%, 0%);

  -webkit-transition: -webkit-transform 0s linear 0s;
  transition: transform 0s linear 0s;


  /* using flexbox for vertical centering */

  /* Flexbox display */
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;

  /* Vertical alignment */
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;

  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.auth-modal .overlay {
  z-index: 0;
  background: rgba(13, 1, 61, 0.82);
  /* overlay color */

  opacity: 0.0;

  -webkit-transition: opacity 0.2s ease-out 0.05s;
  transition: opacity 0.2s ease-out 0.05s;
}


.auth-modal-content {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;

  margin: 0 auto;

  overflow-y: visible;

  /* background: #000; */

  width: calc(100% - 12em);
  height: 0;
  padding-top: calc((100% - 12em) * 0.5625);
  /* 16:9 calc */
}

/* Scaling to fit within the current Viewport size:
   When viewport aspect ratio is greater than 16:9
   work off the height instead of the width for calc */
@media (min-aspect-ratio: 16/9) {
  .auth-modal-content {
    width: 0;
    height: calc(100vh - 10em);
    padding-top: 0;
    padding-left: calc((100vh - 10em) * 1.7778);
    /* 16:9 calc */
  }
}

/* Mobile Layout Tweaks - side margins reduced */
@media (max-width: 640px) {
  .auth-modal-content {
    width: calc(100% - 1em);
    padding-top: calc((100% - 1em) * 0.5625);
    /* 16:9 calc */
  }
}


.close-auth-modal {
  display: block;
  position: absolute;
  left: 0;
  top: -40px;

  text-decoration: none;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}

.modal-info {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;

  display: flex;
  justify-content: center;
  align-items: center;

  /* background: #000; */
  /* box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.5); */
}

.modal-info-inner {
  background: white;
  padding: 4rem 5rem;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0px 2px 16px rgba(235, 235, 235, 1);
}

.modal-info-inner h3 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.auth-moda-explanations {
  margin: 0 0 1rem 0;
}

.auth-choose-cert {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  background: #36429E;
  color: white;
  cursor: pointer;
}

/* Show modal by adding class to body */
.show-auth-modal .auth-modal {
  opacity: 1.0;

  transform: translate(0%, 0%);
  -webkit-transform: translate(0%, 0%);
}

.show-auth-modal .auth-modal .overlay {
  opacity: 1.0;
}

.show-auth-modal .auth-modal-content {
  transform: translate(0%, 0%);
  -webkit-transform: translate(0%, 0%);
}

</style>